import _ from 'lodash';
import {USER_ROLE} from './user';

export const CANDIDATE_TARIFFS = [
  'free',
  'base',
];

export const CANDIDATE_SERVICES = [
  'record-video-resume',
];

export const EMPLOYER_TARIFFS = [
  'free',
  'base',
  'base-record-video-poll',
  'all-included',
  'record-video-poll',
];

export const EMPLOYER_SERVICES = [
  'record-video-vacancy',
  'staff-recruitment',
  'candidates-flow',
];

export const ACCESS_RECORD_VIDEOSESSION = 'ACCESS_RECORD_VIDEOSESSION';

export const UNLIMITED_RECORD_VIDEOSESSION = 'UNLIMITED_RECORD_VIDEOSESSION';

export const ACCESS_CREATE_VIDEOPOLL = 'ACCESS_CREATE_VIDEOPOLL';

export const UNLIMITED_CREATE_VIDEOPOLL = 'UNLIMITED_CREATE_VIDEOPOLL';

export const CANDIDATE_SERVICE_KEYS = [
  'ACCESS_CREATE_VIDEOSESSION',
  ACCESS_RECORD_VIDEOSESSION,
  'ACCESS_RECORD_VIDEOPOLL',
];

export const EMPLOYER_SERVICE_KEYS = [
  'ACCESS_CREATE_VIDEOSESSION',
  ACCESS_RECORD_VIDEOSESSION,
  ACCESS_CREATE_VIDEOPOLL,
  'ACCESS_DATABASE_RESUME',
  'ACCESS_PUBLICATION_VACANCY',
];

export const ALL_SERVICE_KEYS = [
  'ACCESS_CREATE_VIDEOSESSION',
  ACCESS_RECORD_VIDEOSESSION,
  UNLIMITED_RECORD_VIDEOSESSION,
  'ACCESS_RECORD_VIDEOPOLL',
  'UNLIMITED_RECORD_VIDEOPOLL',
  ACCESS_CREATE_VIDEOPOLL,
  UNLIMITED_CREATE_VIDEOPOLL,
  'UNLIMITED_DATABASE_RESUME',
  'ACCESS_DATABASE_RESUME',
  'UNLIMITED_PUBLICATION_VACANCY',
  'ACCESS_PUBLICATION_VACANCY',
  'APPLICATION_FOR_RECORD_RESUME',
  'APPLICATION_FOR_RECORD_VACANCY',
];

export const TARIFF_DIMENSION = [
  {value: 1, label: 'рублей'},
  {value: 2, label: 'рублей/месяц'},
];

export function tariffImageByName(name) {
  switch (name) {
  case 'Бесплатно': return '../../assets/images/tariffs/ic_plans_free.svg';
  case 'Базовый': return '../../assets/images/tariffs/ic_plans_basic.svg';
  case 'Базовый + Запись видеоопросов': return '../../assets/images/tariffs/ic_plans_basic_plus_record.svg';
  case 'Запись видеоопросов': return '../../assets/images/tariffs/ic_plans_record_videosurveys.svg';
  case 'Запись видеорезюме': return '../../assets/images/tariffs/ic_service_record_cv.svg';
  case 'Все включено': return '../../assets/images/tariffs/ic_plans_all_inclusive.svg';
  case 'Поток кандидатов': return '../../assets/images/tariffs/ic_service_flow_of_candidates.svg';
  case 'Подбор персонала': return '../../assets/images/tariffs/ic_servise_staff_recruitment.svg';
  case 'Запись видеовакансии': return '../../assets/images/tariffs/ic_service_record_vacancy.svg';
  case 'Индивидуальный': return '../../assets/images/tariffs/ic_plans_enterprise.svg';
  default: return '../../assets/images/tariffs/ic_plans_free.svg';
  }
}

export function tariffInCart(tariffId, cartData = {}, userId) {
  const userCartData = cartData[userId] || [];
  return !!_.find(userCartData, {tariffId});
}

export function monthNameByPeriod(period) {
  switch (period) {
  case 1: return 'месяц';
  case 3: return 'месяца';
  case 6: return 'месяцев';
  case 12: return 'месяцев';
  default: return 'месяцев';
  }
}

export function paySum(items) {
  return _.reduce(items, (sum, item) => {
    const t = item.tariff || {};
    const tariffPeriod = item.tariffPeriod || 1;
    const pricePeriods = t.pricePeriods || [];
    const basePrice = t.basePrice || 0;
    const currentPeriod = _.find(pricePeriods, {months: tariffPeriod});
    if (currentPeriod) {
      const periodAmount = (currentPeriod.amount || basePrice) * tariffPeriod;
      return sum + periodAmount;
    }
    return sum + (basePrice * tariffPeriod);
  }, 0);
}

export const SHORT_DESCRIPTION_MAX_TEXT_SIZE = 100;

export const FULL_DESCRIPTION_MAX_TEXT_SIZE = 300;

export const ADDITIONAL_DESCRIPTION_MAX_TEXT_SIZE = 200;

export const MB_PER_HOUR = 850;

export const roleSelectOptions = [
  {value: USER_ROLE.CANDIDATE, label: 'Кандидат'},
  {value: USER_ROLE.EMPLOYER, label: 'Работодатель'},
  {value: USER_ROLE.RECRUITER, label: 'Кадровое агенство'},
];

export const prefixSelectOptions = [{label: '', value: 2}, {label: 'более', value: 1}];

export function getServicesKeyOptionsByRole(role, serviceOptions = []) {
  switch (role) {
  case USER_ROLE.CANDIDATE:
    return serviceOptions.filter((key) => (CANDIDATE_SERVICE_KEYS.includes(key.value)));
  case USER_ROLE.EMPLOYER:
  case USER_ROLE.RECRUITER:
    return serviceOptions.filter((key) => (EMPLOYER_SERVICE_KEYS.includes(key.value)));
  default:
    return [];
  }
}

export function getTariffNameOptions(role, serviceNames = []) {
  switch (role) {
  case USER_ROLE.CANDIDATE:
    return serviceNames
      .map((t) => ({value: t.value, label: t.text.ru}))
      .filter((key) => (CANDIDATE_TARIFFS.includes(key.value)));
  case USER_ROLE.EMPLOYER:
  case USER_ROLE.RECRUITER: return serviceNames
    .map((t) => ({value: t.value, label: t.text.ru}))
    .filter((key) => (EMPLOYER_TARIFFS.includes(key.value)));
  default: return [];
  }
}

export function getServiceNameOptions(role, serviceNames = []) {
  switch (role) {
  case USER_ROLE.CANDIDATE:
    return serviceNames
      .map((t) => ({value: t.value, label: t.text.ru}))
      .filter((key) => (CANDIDATE_SERVICES.includes(key.value)));
  case USER_ROLE.EMPLOYER:
  case USER_ROLE.RECRUITER: return serviceNames
    .map((t) => ({value: t.value, label: t.text.ru}))
    .filter((key) => (EMPLOYER_SERVICES.includes(key.value)));
  default: return [];
  }
}
